import React from 'react';
import PageList from '../../../components/PageListAPI'
import { rolesAllList, rolesAllDel } from '../../../api/list'
import { useHistory, useLocation } from 'react-router-dom'

export default function RolesList() {
  const location = useLocation()
  const history = useHistory()
  return (
    <div className='App-paper'>
      <PageList
        name='roles-all'
        title='Роли'
        columns={[{ id: 'id', name: 'ID' },{ id: 'name', name: 'Название' }]}
        createItem={true}
        deleteItem={true}
        loadAPI={{
          request: rolesAllList,
        }}
        deleteAPI={rolesAllDel}
        location={location}
        history={history}
      />
    </div>
  )
};